import { useState } from 'react'

import cn from 'clsx'
import { createPortal } from 'react-dom'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { InfoIcon } from '@App/static/icons/SpotOrderIcons'
import { BodyPortal } from '@App/ui/crypto_exchange/desktop/components/common/BodyPortal'
import OutsideClickComponent from '@App/ui/crypto_exchange/desktop/components/common/OutsideClickHandler'
import { TickerPrice } from '@App/ui/crypto_exchange/desktop/pages/discover/components/Fallers/components/TickerPrice'
import { calcMargin } from '@App/ui/crypto_exchange/desktop/pages/spot/components/OrderHistory/tables/OrderHistoryTable/utils/calcFunctions'

import s from './styles.module.scss'

const formatNumber = (value: number) =>
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 8,
  }).format(value)
export const GeneralInfo = ({
  quantity,
  tickerDataPrice,
  leverage,
  operationType,
  currency,
  renderDetailsPopUp,
  triggerPrice,
}: {
  quantity: number
  tickerDataPrice: number
  leverage: number
  operationType: 'sell' | 'buy'
  currency: string
  triggerPrice?: number
  renderDetailsPopUp?: (margin: number) => React.ReactNode
}) => {
  const margin = calcMargin(quantity, tickerDataPrice, leverage)
  const [isOpenPopUp, setIsOpenPopUp] = useState(false)
  return (
    <div className={s.container}>
      <div className={cn(s.row, s.horizontal, s.border)}>
        <div className={s.left}>
          <div className={s.title}>
            {operationType.at(0)?.toUpperCase()}
            {operationType.slice(1)} @
          </div>
          <div className={s.value}>{triggerPrice && formatNumber(triggerPrice)}</div>
        </div>
        <div className={s.right}>
          <div className={s.title}>Current</div>
          <TickerPrice price={tickerDataPrice} classNames={s.tickerValue}>
            {tickerDataPrice}
          </TickerPrice>
        </div>
      </div>

      <div className={cn(s.row, s.border)}>
        <div className={s.title}>Margin reserved</div>{' '}
        <div className={s.margin}>{getValueWithCurrency(currency, Number(margin))}</div>
      </div>

      <div className={s.row}>
        <div className={s.title}>
          Order details <InfoIcon className={s.infoIcon} onClick={() => setIsOpenPopUp(true)} />
        </div>
      </div>
      {isOpenPopUp && renderDetailsPopUp && (
        <BodyPortal>
          <OutsideClickComponent className={s.popUpContainer} handler={() => setIsOpenPopUp(false)}>
            {renderDetailsPopUp?.(Number(margin))}
          </OutsideClickComponent>
        </BodyPortal>
      )}
    </div>
  )
}
